import { checkIfCollectionCoursePage } from '@/router'

export default {
    computed: {
        isMicroLearningButNotInCollection () {
            return this.isMicroLearningCourse && !this.isCollectionCoursePage
        },
        shouldAutoPlayVideo () {
            return this.shouldAutoPlay || this.getAutoPlaySettingFromRouteQuery
        },
        getAutoPlaySettingFromRouteQuery () {
            if (this.$route.query.autoplay === undefined) {
                return false
            } else {
                return this.$route.query.autoplay
            }
        },
        isLastCollectionVideo () {
            if (!this.isCollectionCoursePage) {
                return true
            }
            return this.singleCollectionCourses[this.singleCollectionCourses.length - 1].id === this.course.id
        },
        isCollectionCoursePage () {
            return checkIfCollectionCoursePage(this.$route.name)
        }
    },
    methods: {
        onPlayerCompleted () {
            switch (this.playerType) {
            case 'Vimeo':
                this.resetVimeoPlayer()
                break
            case 'JWPlayer':
                this.resetJWPlayer()
                break
            }
            this.videoFinished = true
            if (this.isMicroLearningButNotInCollection) {
                if (!this.isLastSection && this.getNextSection().type === 'video') {
                    this.setVideoCountDownVisible()
                } else if (this.isCourseTestAvailable && !this.courseCompleted) {
                    this.showCourseTestNotification = true
                }
            } else if (this.isCollectionCoursePage) {
                if (this.isMicroLearningCourse) {
                    if (!this.isLastSection) {
                        this.setVideoCountDownVisible()
                    } else if (this.isCourseTestAvailable && !this.courseCompleted) {
                        this.showCourseTestNotification = true
                    } else if (this.isLastSection && !this.isLastCollectionVideo) {
                        this.setVideoCountDownVisible()
                    }
                } else {
                    if (this.isCourseTestAvailable && !this.courseCompleted) {
                        this.showCourseTestNotification = true
                    } else if (!this.isLastCollectionVideo) {
                        this.setVideoCountDownVisible()
                    }
                }
            } else if (this.isCourseTestAvailable && !this.courseCompleted) {
                this.showCourseTestNotification = true
            }
        },
        resetVimeoPlayer () {
            let exitFullscreen = document.exitFullscreen ||  document.webkitExitFullscreen
            if (exitFullscreen) {
                exitFullscreen.call(document)
            }
            this.player.pause()
            this.moveVideoToPoint(0)
            this.currentSeqtionStart = 0
            this.isPlaying = false
        },
        resetJWPlayer () {
            this.player.stop()
            this.moveVideoToPoint(0)
            this.player.pause()
            this.currentSeqtionStart = 0
        },
        hideCourseTestNotification () {
            this.showCourseTestNotification = false
            this.redirectToNext()
        }
    }

}
